export default "__VITE_ASSET__c408cc1f__"